import { ImageData } from '../PhotoUploadActionCard'
import { IssueSubmissionResult, IssueType } from '../ReportIssue/types'

export enum HeaderType {
  SUCCESS = 'success',
  WARNING = 'warning',
  INFO = 'info',
}

export interface IssueData {
  trackingId: string
  issueType: string
  issueDetail: string
  issueSubmissionResult: string
  name?: string
  email?: string
  cellPhone?: string
  consentChecked: boolean
  imageData?: ImageData | null
  issueId?: string
  taskCreated?: boolean
}

export interface SubmissionHeaderProps {
  headerType: HeaderType
  headerText: string
  headerBodyText: string
}

export interface SubmissionBodyProps {
  issueId: string
  imageData?: ImageData | null
  issueType: IssueType
  issueDetail: string
  name?: string
  email?: string
  cellPhone?: string
}

// Re-export for convenience
export { IssueSubmissionResult, IssueType }
